import { EsAuthor } from '../../../models/EsAuthor';
import { UsersSupervisedActionConstant } from '../action/users-supervised.action';
import { createAction, createReducer, on, props } from '@ngrx/store';

export class UsersSupervisedState {
  datas: EsAuthor[];
  loading: boolean;
  error: any;
}

export const USERS_SUPERVISEDINITIAL_STATE: UsersSupervisedState = {
  datas: [],
  loading: false,
  error: null,
};




export const loadUsersSupervisedStartedAction = createAction(UsersSupervisedActionConstant.LOAD_USERS_SUPERVISED_STARTED);
export const loadUsersSupervisedSucceedAction = createAction(UsersSupervisedActionConstant.LOAD_USERS_SUPERVISED_SUCCEEDED, props<{payload: EsAuthor[]}>());
export const loafUsersSupervisedFailedAction = createAction(UsersSupervisedActionConstant.LOAD_USERS_SUPERVISED_FAILED, props<{error: Error}>());

export const usersSupervisedReducer = createReducer(
  USERS_SUPERVISEDINITIAL_STATE,
  on(loadUsersSupervisedStartedAction, (state) => ({
    ...state,
    loading: true,
    error: null,
  }) ),
  on(loadUsersSupervisedSucceedAction, (state, {payload}) => ({
    ...state,
    datas: [...state.datas, ...payload],
    loading: false,
    error: null,
  }) ),
  on(loafUsersSupervisedFailedAction, (state,{error}) => ({
    ...state,
    loading: false,
    error: error,
  }) ),
)
